// extracted by mini-css-extract-plugin
export default {"root":"WhiteBox_root__kk9kI"};